"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MergeCartContent = void 0;
exports.MergeCartContent = {
  en: {
    title: "Item%plural% Added",
    message: "We have merged %number% item%plural% into your cart.",
    ok: "OK",
    reviewCart: "Review Cart",
    back: "back"
  },
  fr: {
    title: "Article%plural% ajouté%plural%",
    message: "Nous avons fusionné %number% article%plural% dans votre panier.",
    ok: "OK",
    reviewCart: "Réviser le panier",
    back: "retour"
  },
  es: {
    title: "Elemento%plural% agregado%plural%",
    message: "Hemos fusionado %number% artículo%plural% en su carrito.",
    ok: "OK",
    reviewCart: "Revisar carro",
    back: "espalda"
  }
};